import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { SearchState } from '@/types/models'
import { isNonEmptyArray } from '@/utils/checks'
export const getMatchedBrowsePrimaryFocus = ({
  searchState,
  primaryFocusMap
}: {
  searchState: SearchState
  primaryFocusMap: Record<string, PrimaryFocus>
}): PrimaryFocus | '' => {
  if (!isNonEmptyArray(searchState?.refinementList?.what_we_treat)) {
    return ''
  }

  const unifiedPrimaryFocus = searchState?.refinementList?.what_we_treat
    .map((term: string) => primaryFocusMap[term])
    .filter(Boolean)

  const hasSamePrimaryFocus = unifiedPrimaryFocus.every(
    (term: string) => term === unifiedPrimaryFocus[0]
  )

  if (isNonEmptyArray(unifiedPrimaryFocus) && hasSamePrimaryFocus) {
    return unifiedPrimaryFocus[0] as PrimaryFocus
  }
  return ''
}
